import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DynamicForm from '../../../components/dynamicForm';
import { ticketSchema } from '../../../formData/ticketSchema';
import { showSuccess } from '../../../components/showSuccess';

export default function TicketPage() {
    const navigate = useNavigate();
    const [formVisible, setFormVisible] = useState(true);
    const [initialData] = useState({
        ticker: 'LoremIpsum',
        stateCode: ''
    });

    const handleAction = async (action, data) => {
        if (action === 'cancel') {
            navigate(-1);
        }
        if (action === 'save') {
            // TODO: persist data via API
            await showSuccess('Ticker Saved Successfully!');
            navigate(-1);
        }
    };

    const baseUrl = window.location.origin;
    const clientUrl = `${baseUrl}/client/donation/?ticker=${initialData.ticker}`;

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Ticker</h1>
            <div style={styles.card}>
                <div style={styles.cardHeader}>
                    <div style={styles.tickerInfo}>
                        <div style={styles.label}>
                            Your Ticker: <strong>{initialData.ticker}</strong>
                        </div>
                        <div style={styles.url}>
                            URL: <a href={clientUrl}>{clientUrl}</a>
                        </div>
                    </div>
                </div>

                {/* Dynamic form for ticker & state */}
                {formVisible && (
                    <DynamicForm
                        formStyle={styles.formStyle}
                        buttonHolderStyle={styles.buttonHolderStyle}
                        actionButtonStyle={styles.actionButtonStyle}
                        schema={ticketSchema}
                        mode="edit"
                        initialData={initialData}
                        onAction={handleAction}
                    />
                )}
            </div>
        </div>
    );
}

const styles = {
    container: {
        margin: '0 auto',
        color: '#333',
    },
    title: {
        fontSize: 24,
        marginTop: 0,
        color: '#4a5568',
    },
    card: {
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        padding: 24,
    },
    cardHeader: {
        marginBottom: 24,
    },
    tickerInfo: {
        lineHeight: 1.5,
    },
    label: {
        fontSize: 16,
        marginBottom: 4,
    },
    url: {
        fontSize: 14,
        color: '#555',
    },
    formStyle: {
        marginTop: '24px',
        display: 'inline-block'
    },
    buttonHolderStyle: {
        marginTop: '44vh',
        width: '100%',
        float: 'right',
        borderTop: 'solid 1px #ccc',
        paddingTop: '34px',
        justifyContent: 'right'
    },
    actionButtonStyle: {
        maxWidth: '150px'
    }
};